import Project from './Project';

class WorkSection {
  constructor({ el, wWidth }) {
    this.wWidth = wWidth;
    this.breakpoint = 768;
    this.isMobile = this.wWidth < this.breakpoint;
    this.projects = [];
    this.visibleRows = this.isMobile ? 1 : 3;

    this.$rows = $(el).find('.work__row');
    this.$projects = this.$rows.find('.work__project');
    this.$loadMore = $(el).find('.work__load-more');
    this.rowsCount = this.$rows.length;

    this.init();
    this.initLoadMore();
  }

  init() {
    // add is visible class to the initially visible rows
    this.$rows.slice(0, this.visibleRows).addClass('is-active');

    this.$projects.each((index, el) => {
      this.projects.push(
        new Project({
          el,
          wWidth: this.wWidth,
          isMobile: this.isMobile,
          index,
        })
      );
    });

    this.alignDescription();
  }

  initLoadMore() {
    this.$loadMore.on('click', () => {
      const self = this;
      const currentRowIndex = this.visibleRows;

      // show the next row
      this.$rows.eq(this.visibleRows).slideDown({
        duration: 600,
        start() {
          $(this).css('display', 'grid');
        },
        complete() {
          $(this).addClass('is-active');
          self.restartAnimations(currentRowIndex);
        },
      });

      // if we're on the last row, hide the load more button
      if (this.visibleRows === this.rowsCount - 1) {
        this.$loadMore.addClass('is-hidden');
      }

      this.visibleRows += 1;
    });
  }

  // restart animation for revealed projects
  restartAnimations(currentRowIndex) {
    const projectIndexesToRestart = [
      currentRowIndex * 3 + 0,
      currentRowIndex * 3 + 1,
      currentRowIndex * 3 + 2,
    ];

    projectIndexesToRestart.forEach((index) => {
      const project = this.projects[index];
      if (!project) return;
      project.resetAnimation();
    });
  }

  alignDescription() {
    this.$rows.each((index, el) => {
      const $row = $(el);
      const $descriptions = $row.find('.work__description');

      // reset min-height
      $descriptions.css('min-height', 0);

      // don't align descriptions on mobile
      if (this.isMobile) return;

      // get the tallest description
      let tallestDescriptionHeight = 0;
      $descriptions.each((i, element) => {
        const $description = $(element);
        const descriptionHeight = $description.height();
        if (descriptionHeight > tallestDescriptionHeight) {
          tallestDescriptionHeight = descriptionHeight;
        }
      });

      // set the tallest description height to all descriptions
      $descriptions.css('min-height', tallestDescriptionHeight);
    });
  }

  destroy() {
    this.projects.forEach((project) => {
      if (project.destroy) project.destroy();
    });
    this.projects = [];
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.isMobile = this.wWidth < this.breakpoint;
    this.destroy();
    this.init();
  }
}

export default WorkSection;
